import Vue from 'vue'
import LongPress from 'vue-directive-long-press'

Vue.directive('long-press', LongPress)



// WEBPACK FOOTER //
// ./src/plugins/vue-directive-long-press.js